import { Row } from 'antd'
import { ServicesSection } from './ServicesSection'
import * as Styles from './styles'
import { TicketSection } from './TicketSetction'
import { Col17, Col7 } from 'src/components/Columns'
import { useEffect } from 'react'
import useUserPermission from 'src/hooks/useUserPermissions'
import { USER_SCOPES } from 'src/hooks/UserPermission'

export const CreateServiceContract = () => {
    const { validateUserScopeForPage } = useUserPermission()

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.SERVICE_CONTRACT_CREATE)
    }, [])

    const renderTicketSection = () => {
        return <TicketSection />
    }

    const renderItemsSection = () => {
        return <>
            <Styles.ItemsSection>
                <ServicesSection />
            </Styles.ItemsSection>
        </>
    }

    const renderContent = () => {
        return <Styles.ContentContainer>
            <Row style={{ width: '100%' }} >
                <Col17>
                    {renderItemsSection()}
                </Col17>
                <Col7>
                    <>
                        <Styles.TicketSection>
                            {renderTicketSection()}
                        </Styles.TicketSection>
                    </>
                </Col7>
            </Row>
        </Styles.ContentContainer>
    }

    return (
        <>
            <Styles.ParentContainer>
                <Styles.Filler>
                    {renderContent()}
                </Styles.Filler>
            </Styles.ParentContainer>
        </>
    )
}
